export const CLIPBOARD_KIND = 'Variables';
